import React, { Component } from 'react';
import PropTypes from 'prop-types';
import  { HighchartsChart, Chart, XAxis, YAxis, LineSeries, withHighcharts } from 'react-jsx-highcharts';
import Highcharts from 'highcharts'
import { defaultsDeep } from 'lodash'
import withHooks from 'cityads-v3/decorators/withHooks'
import { useThemeChanger } from 'cityads-v3/hooks/theme'

import NumberFormat, { FORMAT_NUMBER, FORMAT_PERCENT } from 'cityads-v3/components/Format/NumberFormat';
import Typography from '@material-ui/core/Typography'

import Base from './Base';
import classNames from './Graph.scss';

import { sassExportsToObjectRecursive } from 'cityads-v3/utils/styleUtils';

const sassExports = sassExportsToObjectRecursive(classNames);

@withHooks(props => ({
  ...props,
  themeChanger: useThemeChanger()
}))
export class Graph extends Component {
  static propTypes = {
    points: PropTypes.array,
  }

  state = {
    selectedPointIndex: null,
  }

  constructor() {
    super(...arguments);

    // Один и тот же единождый созданный объект
    // Литерал в render приведёт к перерисовке графика на каждом рендере
    this.seriesPointParams = {
      events: {
        mouseOver: (evt) => {
          // setTimeout, чтобы не начать перерисовывать чарт изнутри стека обработки события
          setTimeout(() => this.setState({ selectedPointIndex: evt.target.index }), 0);
        }
      }
    };
  }

  componentDidMount() {
    this.updateStateFromProps(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateStateFromProps(nextProps);
  }

  updateStateFromProps(props) {
    this.setState({
      selectedPointIndex: props.points && props.points.length - 1
    });
  }

  render() {
    const points = this.props.points;

    const selectedPointIndex = this.state.selectedPointIndex;
    const currentPoint = points && points[selectedPointIndex];
    const currentPointValue = (currentPoint && currentPoint.y) || null;

    const TICK_INTERVAL = 3;

    let currentPointDiff = null;
    let currentPointDiffRatio = null;

    if (points && points.length >= 2) {
      currentPointDiff = selectedPointIndex > 0 ? currentPointValue - points[selectedPointIndex - 1].y : points[selectedPointIndex + 1].y - currentPointValue;
      currentPointDiffRatio = selectedPointIndex > 0 ? currentPointDiff /  points[selectedPointIndex - 1].y : currentPointDiff / currentPointValue;
    }

    const tickPositions = points ? points.filter((pt, idx, arr) => !idx || idx % TICK_INTERVAL === 0 || idx === arr.length-1).map(pt => pt.x) : [];

    const highchartsOptionsLight = sassExports.highchartsOptions
    const highchartsOptionsDark = defaultsDeep(sassExports.highchartsOptionsDark, highchartsOptionsLight)
    const highchartsOptions = this.props.themeChanger.theme.palette.type === 'dark'
      ? highchartsOptionsDark
      : highchartsOptionsLight

    if (typeof highchartsOptions.chart.spacing === 'string') {
      highchartsOptions.chart.spacing = highchartsOptions.chart.spacing.split(/,\s*/).map(Number);
    }

    highchartsOptions.xAxis.tickLength = Number(highchartsOptions.xAxis.tickLength);
    highchartsOptions.xAxis.labels.format = '{value:%e}';

    return (
      <Base className={classNames.graphWidget}>
        <div className={classNames.currentData}>
          {
            currentPointValue !== null && (
              <div className={classNames.currentPoint}>
                <NumberFormat number={currentPointValue} format={FORMAT_NUMBER} precision={0} />
              </div>
            )
          }

          {
            currentPointDiff !== null && (
              <div className={classNames.currentDiff}>
                <Typography color="textPrimary" className={classNames.diffDirection}>
                  { (currentPointDiff > 0) ? '↑' : (currentPointDiff < 0) ? '↓' : '=' }
                </Typography>

                <NumberFormat number={currentPointDiff} format={FORMAT_NUMBER} precision={0} />
                (<NumberFormat number={currentPointDiffRatio * 100} format={FORMAT_PERCENT} />)
              </div>
            )
          }
        </div>

        {typeof window !== 'undefined' && (
          <HighchartsChart plotOptions={highchartsOptions.plotOptions} className={classNames.widgetChart}>
            <Chart {...highchartsOptions.chart} />

            <XAxis id="date" tickPositions={tickPositions} {...highchartsOptions.xAxis} />

            <YAxis id="amount" {...highchartsOptions.yAxis} >
              <LineSeries
                id    = "conversions"
                data  = {points}
                point = {this.seriesPointParams}
                {...highchartsOptions.series}
              />
            </YAxis>

          </HighchartsChart>
        )}
      </Base>
    );
  }
}

export default withHighcharts(Graph, Highcharts)
